import { useCallback, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRequestHeaders } from "../../../../core/hooks/useRequestHeaders";
import { AuthContext } from "../../../../core/providers/AuthContext";
import useEmployeeStoreState from "../EmployeeStoreState";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useInfo = () => {
  const { t } = useTranslation();
  const headers = useRequestHeaders();
  const { logout } = useContext(AuthContext);
  let history = useHistory();

  const {
    loadingInfo,
    errorLoadingInfo,
    initialInfo,
    fetchInitialInfo,
    firstInitialInfoCompleted,
    showClosedEmsDialog,
    openClosedEmsDialog,
    closeClosedEmsDialog,
    alreadyShownClosedEmsDialog,
    showDialogNoActiveCatalog,
    openNoActiveCatalogDialog,
    closeNoActiveCatalogDialog,
    fetchPreCheckoutInfo,
    preCheckoutInfo,
    closePreCheckoutConfirmationDialog,
    showErrorEmsCountryMissmatch,
    showErrorEmsClientMissmatch,
    amountMonth,
    changeOpenEmsByDefault,
  } = useEmployeeStoreState((state) => ({
    loadingInfo: state.loadingInfo,
    errorLoadingInfo: state.errorLoadingInfo,
    initialInfo: state.initialInfo,
    fetchInitialInfo: state.fetchInitialInfo,
    firstInitialInfoCompleted: state.firstInitialInfoCompleted,
    showClosedEmsDialog: state.showClosedEmsDialog,
    openClosedEmsDialog: state.openClosedEmsDialog,
    closeClosedEmsDialog: state.closeClosedEmsDialog,
    alreadyShownClosedEmsDialog: state.alreadyShownClosedEmsDialog,
    showDialogNoActiveCatalog: state.showDialogNoActiveCatalog,
    openNoActiveCatalogDialog: state.openNoActiveCatalogDialog,
    closeNoActiveCatalogDialog: state.closeNoActiveCatalogDialog,
    fetchPreCheckoutInfo: state.fetchPreCheckoutInfo,
    preCheckoutInfo: state.preCheckoutInfo,
    closePreCheckoutConfirmationDialog:
      state.closePreCheckoutConfirmationDialog,
    showErrorEmsCountryMissmatch: state.showErrorEmsCountryMissmatch,
    showErrorEmsClientMissmatch: state.showErrorEmsClientMissmatch,
    amountMonth: state.amountMonth,
    changeOpenEmsByDefault: state.changeOpenEmsByDefault,
  }));

  const handleFetchInitialInfo = useCallback(() => {
    fetchInitialInfo(headers, logout, t);
  }, [fetchInitialInfo, headers, logout, t]);

  const handleFetchPreCheckoutInfo = useCallback(async () => {
    return await fetchPreCheckoutInfo(headers, logout, t);
  }, [fetchPreCheckoutInfo, headers, logout, t]);

  const handleChangeOpenEmsByDefault = useCallback(
    async (newValue) => {
      return await changeOpenEmsByDefault(headers, logout, newValue);
    },
    [headers, logout, changeOpenEmsByDefault]
  );

  const handleCloseDialog = useCallback(() => {
    if (initialInfo?.isEmsAdmin === true) {
      history.push("/");
    } else {
      logout(false);
    }
  }, [logout, initialInfo, history]);

  const isEmsAdmin = useMemo(() => {
    return initialInfo?.isEmsAdmin === true;
  }, [initialInfo]);

  return {
    handleFetchInitialInfo,
    loadingInfo,
    errorLoadingInfo,
    initialInfo,
    firstInitialInfoCompleted,
    handleCloseDialog,
    showClosedEmsDialog,
    openClosedEmsDialog,
    closeClosedEmsDialog,
    alreadyShownClosedEmsDialog,
    isEmsAdmin,
    showDialogNoActiveCatalog,
    openNoActiveCatalogDialog,
    closeNoActiveCatalogDialog,
    handleFetchPreCheckoutInfo,
    preCheckoutInfo,
    closePreCheckoutConfirmationDialog,
    showErrorEmsCountryMissmatch,
    showErrorEmsClientMissmatch,
    amountMonth,
    handleChangeOpenEmsByDefault,
  };
};

export default useInfo;
